import React, { useState, useEffect, useContext } from 'react'
import { useParams, useHistory, Link } from 'react-router-dom'
import { Layout } from '../../components/Layout'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'
import { Card } from 'primereact/card'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { CoursesService } from '../../services/Courses'
import './styles.scss'

export const CourseUses = () => {
  const { id } = useParams()
  const history = useHistory()
  const { isAuth: token } = useContext(Context)
  const [, setCourseData] = useState(null)
  const [usesData, setUsesData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    getCourseUses()
  }, [id])

  const getCourseUses = async () => {
    try {
      setIsLoading(true)

      // Obtener datos del curso
      const courseResponse = await CoursesService.getById(id, token)
      setCourseData(courseResponse)

      // Obtener usuarios del curso
      const usersResponse = await CoursesService.getcoursesxUserE(id, token)

      // Transformar los datos para que coincidan con la estructura esperada
      const transformedData = usersResponse.map((user, index) => ({
        id: user.id,
        studentId: user.id,
        studentName: user.name,
        studentEmail: user.email,
        role: user.role,
      }))

      setUsesData(transformedData)
    } catch (e) {
      setError('Error al cargar los usos del curso')
      console.error('Error:', e)
    } finally {
      setIsLoading(false)
    }
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <Link to={`${GLOBALS.menu.courses.link}/uses/${id}/student/${rowData.studentId}`}>
        <Button
          type="button"
          icon="pi pi-eye"
          className="p-button-info action-button"
          tooltip="Ver detalles"
          tooltipOptions={{ position: 'top' }}
        />
      </Link>
    )
  }

  const columns = [
    {
      field: 'studentName',
      header: 'Nombre',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por nombre',
    },
    {
      field: 'studentEmail',
      header: 'Correo',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por correo',
    },
    {
      field: 'actions',
      header: 'Acciones',
      sortable: false,
      body: actionBodyTemplate,
    },
  ]

  if (isLoading) {
    return (
      <Layout>
        <div className="course-uses-container">
          <div className="loading-container">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
            <p>Cargando usos del curso...</p>
          </div>
        </div>
      </Layout>
    )
  }

  if (error) {
    return (
      <Layout>
        <div className="course-uses-container">
          <Message severity="error" text={error} />
          <Button
            label="Volver"
            icon="pi pi-arrow-left"
            onClick={() => history.goBack()}
            className="p-button-secondary"
          />
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className="course-uses-container">
        <div className="course-uses-header">
          <Button
            label="Volver"
            icon="pi pi-arrow-left"
            onClick={() => history.goBack()}
            className="p-button-secondary back-button"
          />
          <h1>
            <i className="pi pi-chart-bar"></i>
            Usos del Curso
          </h1>
        </div>

        <Card className="uses-table-card">
          <DataTable
            value={usesData}
            paginator
            rows={50}
            rowsPerPageOptions={[10, 25, 50]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            emptyMessage="No se encontraron usos para este curso"
            className="p-datatable-custom"
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                filter={col.filter}
                filterPlaceholder={col.filterPlaceholder}
                body={col.body}
              />
            ))}
          </DataTable>
        </Card>
      </div>
    </Layout>
  )
}
